import React, { useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { useNotificationAlertError } from '../../../../../context/notification/type-alert'
import { useApiFormAnalyticTopic, useApiListAnalyticParent } from '../../../../../api-new/state/analytics'
import { useLoad } from '../../../../../shared/hooks/load'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconAdd } from '../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../shared/card/card'
import { Form, FormHiddenNumber, FormHiddenText, FormSubmitCancel, FormText, FormTextArea } from '../../../../../shared/form/form'
import { useRoleOrgAnalytic } from '../../../../../role/hook/role-org'

export const AnalyticCourseTopicEdit = () => {
  const { nodeID, id } = useParamsInt()

  const history = useHistory()

  const roleOrgAnalytic = useRoleOrgAnalytic()

  const alert = useNotificationAlertError()

  const apiListAnalyticParent = useApiListAnalyticParent()
  const apiFormAnalyticTopic = useApiFormAnalyticTopic()

  const [analyticParentID, updateAnalyticParentID] = useState()

  const disable = useMemo(
    () => {
      if (!roleOrgAnalytic.accessUpdate) {
        return true
      }

      if (!analyticParentID) {
        return true
      }

      return false
    },
    [analyticParentID, roleOrgAnalytic]
  )

  useLoad(async () => {
    let analyticParents = await apiListAnalyticParent.get()
    let analyticParentCourse = analyticParents.find(i => i.name === 'course')
    if (analyticParentCourse) {
      updateAnalyticParentID(analyticParentCourse.id)
      alert.hide()
    } else {
      alert.show(`analytic parent: "course" not found`, false)
    }
  }, [])

  const handleMatch = async () => apiFormAnalyticTopic.get(id)

  const handleSubmit = async data => {
    await apiFormAnalyticTopic.put(data.id, data)
    history.goBack()
  }

  const handleClose = () => history.goBack()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Edit" onMatch={handleMatch}>
        <CardFullHeightScrollY title="Edit Topic">
          <Card>
            <Form state={apiFormAnalyticTopic.form} disabled={disable} onSubmit={handleSubmit} onRefresh={handleMatch}>
              <FormHiddenNumber name="analyticParentID" value={analyticParentID} />
              <FormHiddenText name="parentID" value={nodeID} />
              <FormText label="name" name="name" small autoFocus />
              <FormTextArea label="description" name="description" small />
              <FormSubmitCancel small onCancel={handleClose} />
            </Form>
          </Card>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
